import posthogActions from './posthog-actions';
import { posthog, posthogReady, POSTHOG_ENABLED } from './posthog-bootstrap';

const NOOP: posthogActions = ({
    applyConsentPSM() { },
    capture() { },
    captureContactForm() { },
    captureGiftCardPurchase() { },
    captureNewsletterForm() { },
    captureSignupForm() { },
    captureDownPartyPurchase() { },
    captureBooking() { },
} as unknown as posthogActions);

const isSSR = typeof window === 'undefined';
const isDisabled = isSSR || !POSTHOG_ENABLED;

let instance: posthogActions;

declare global {
  interface Window { __PH_SINGLETON__?: posthogActions }
}

const ph: posthogActions =
  (isDisabled)
    ? NOOP
    : (window.__PH_SINGLETON__ ||= (instance ||= new posthogActions({ ph: posthog, ready: posthogReady })));

export default ph;